/**
 * Cache-busting for CDN assets served from fixed URLs.
 *
 * CDN/browser caches key on the URL, so overwriting an asset in place keeps
 * the stale copy until its max-age expires. Bump CDN_ASSET_VERSION whenever a
 * CDN icon/image is re-uploaded to force every client to fetch the new bytes.
 */
export const CDN_ASSET_VERSION = "1";

export const withAssetVersion = (url: string): string =>
    `${url}${url.includes("?") ? "&" : "?"}v=${CDN_ASSET_VERSION}`;
